import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

// Extract plain text from portable text blocks
const extractPlainText = (blocks) => {
  if (!blocks) return "";
  return blocks
    .filter((block) => block._type === "block")
    .map((block) =>
      block.children
        ?.filter((child) => child._type === "span")
        .map((span) => span.text)
        .join(""),
    )
    .join(" ");
};

// Truncate text to max characters
const truncateText = (text, maxLength = 120) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + "...";
};

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "blog"] | order(publishedAt desc) {
      _id,
      title,
      slug,
      publishedAt,
      body,
      "featuredImageUrl": featuredImage.asset->url
    }`;
    const encodedQuery = encodeURIComponent(query);

    fetch(
      `https://wtagmpvu.apicdn.sanity.io/v2025-10-24/data/query/production?query=${encodedQuery}&perspective=published`,
    )
      .then((response) => response.json())
      .then((data) => {
        setPosts(data.result);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blog posts:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Latest Blog Posts
        </h1>
        <p className="text-gray-600">Loading posts...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
        Latest Blog Posts
      </h1>

      {posts && posts.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((post) => (
            <Link
              to={`/blog/${post.slug?.current}`}
              key={post._id}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col"
            >
              {/* Featured Image */}
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={post.featuredImageUrl}
                  alt={post.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-grow bg-theme">
                <h2 className="text-xl font-bold text-white mb-2 line-clamp-2">
                  {post.title}
                </h2>
                <p className="text-white text-sm mb-4 line-clamp-2 flex-grow">
                  {truncateText(extractPlainText(post.body), 120)}
                </p>
                <button className="self-start bg-white text-theme font-medium px-5 py-2 rounded-full hover:text-opacity-80 transition-colors">
                  Read more
                </button>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <p className="text-gray-600">No blog posts yet. Check back soon!</p>
      )}
    </div>
  );
}
